"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _reactRouterDom = require("react-router-dom");

var _warning = _interopRequireDefault(require("warning"));

var _appLocation = _interopRequireDefault(require("app-location"));

var _parseUtils = require("./parseUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function isEmptyChildren(children) {
  return _react.default.Children.count(children) === 0;
}

;

var Location =
/*#__PURE__*/
function (_LocationCore) {
  _inherits(Location, _LocationCore);

  function Location(path) {
    var pathParamDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var queryStringParamDefs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Location);

    return _possibleConstructorReturn(this, _getPrototypeOf(Location).call(this, path, pathParamDefs, queryStringParamDefs));
  }

  _createClass(Location, [{
    key: "toLink",
    value: function toLink(children, params) {
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      (0, _warning.default)(!props.to, 'toLink props should not include a to prop; it will be overwritten');

      var linkProps = _objectSpread({}, props, {
        to: this.toUrl(params)
      });

      return _react.default.createElement(_reactRouterDom.Link, linkProps, children);
    }
  }, {
    key: "toRoute",
    value: function toRoute(renderOptions) {
      var _this = this;

      var exact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var sensitive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var component = renderOptions.component,
          _render = renderOptions.render,
          _children = renderOptions.children,
          invalid = renderOptions.invalid;
      (0, _warning.default)(component || _render || _children, 'Location.toRoute requires renderOptions argument, which must include either component, render or children property');
      (0, _warning.default)(invalid, 'Location.toRoute requires renderOptions argument, which must include an invalid property, indicating the component to render when the a matched location contains an invalid parameter');
      var routeProps = {
        path: this.path,
        exact: exact,
        strict: strict,
        sensitive: sensitive
      };

      var getPropsWithParams = function getPropsWithParams(props) {
        var location = props.location,
            match = props.match;

        var tokens = _this.parseLocationParams(location, match);

        if (tokens === null) {
          return null;
        } //todo: warn about collisions between route params and qs params


        return _objectSpread({}, props, tokens);
      };

      if (component) {
        return _react.default.createElement(_reactRouter.Route, _extends({}, routeProps, {
          render: function render(props) {
            var propsWithParams = getPropsWithParams(props);

            if (propsWithParams === null) {
              //schema validation error ocurred, render Invalid component
              return _react.default.createElement(invalid);
            }

            return _react.default.createElement(component, propsWithParams);
          }
        }));
      } else if (_render) {
        return _react.default.createElement(_reactRouter.Route, _extends({}, routeProps, {
          render: function render(props) {
            var propsWithParams = getPropsWithParams(props);

            if (propsWithParams === null) {
              //schema validation error ocurred, render Invalid component
              return _react.default.createElement(invalid);
            }

            return _render(propsWithParams);
          }
        }));
      } else if (typeof _children === "function") {
        return _react.default.createElement(_reactRouter.Route, _extends({}, routeProps, {
          children: function children(props) {
            var match = props.match;

            if (match) {
              var propsWithParams = getPropsWithParams(props);

              if (propsWithParams === null) {
                //schema validation error ocurred, render Invalid component
                return _react.default.createElement(invalid);
              }

              return _children(propsWithParams);
            } else {
              return _children(props);
            }
          }
        }));
      } else if (_children && !isEmptyChildren(_children)) {
        (0, _warning.default)(false, 'Location params are not passed as props to children arrays. Use a children function prop if needed.');
        return _react.default.createElement(_reactRouter.Route, _extends({}, routeProps, {
          children: _children
        }));
      }
    }
  }, {
    key: "parseLocationParams",
    value: function parseLocationParams() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window && window.location;
      var match = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _reactRouter.matchPath)(location.pathname, {
        path: this.path
      });
      (0, _warning.default)(location, 'location must be explicitly provided when window object is not available.');
      (0, _warning.default)(location.pathname != undefined && location.search != undefined, 'location object must include pathname and search properties.');
      (0, _warning.default)(location.pathname, 'location.pathname is required.');

      if (!match) {
        (0, _warning.default)(false, 'location.pathname does not match Location.path.');
        return null;
      }

      try {
        if (!this._paramSchema) {
          return {};
        }

        var rawParams = _objectSpread({}, match.params, (0, _parseUtils.parseQueryString)(location.search));

        return this._paramSchema.validateSync(rawParams);
      } catch (err) {
        var name = err.name,
            errors = err.errors;

        if (name === 'ValidationError') {
          (0, _warning.default)(false, "Location.parseLocationParams: ".concat(errors[0]));
        } else {
          throw err;
        }

        return null;
      }
    }
  }]);

  return Location;
}(_appLocation.default);

exports.default = Location;